import { placePreviewSchema } from '@/types/state/shared';
import { z } from 'zod';
import { dealsSearchPreviewSectionSchema } from './dealSearch';
import { dealItemBaseSchema } from './shared';

export const dealDetailsSchema = dealItemBaseSchema.extend({
  type: z.literal(7),
  publicationType: z.literal(2),
  place: placePreviewSchema,
});

export const dealDetailsResponseSchema = z.object({
  deal: dealDetailsSchema.nullable(),
  sections: z.array(dealsSearchPreviewSectionSchema),
});

const dealErrorTypeSchema = z.enum(['not_found', 'targetGroup', 'maxCount', 'maxCustomerCount', 'expired', 'error']);

export type DealErrorType = z.infer<typeof dealErrorTypeSchema>;

export const dealDetailsErrorResponseSchema = z.object({
  error: z.object({
    type: dealErrorTypeSchema,
    deal: dealDetailsSchema.nullable(),
  }),
  sections: z.array(dealsSearchPreviewSectionSchema),
});

export const dealDetailByErpIdResponseSchema = z.object({
  redirect: z.string(),
});

// --- Types ---
export type DealDetailsResponse = z.infer<typeof dealDetailsResponseSchema>;
export type DealDetailByErpIdResponse = z.infer<typeof dealDetailByErpIdResponseSchema>;
export type DealDetailItem = DealDetailsResponse['deal'];
export type DealDetailSearchPreview = DealDetailsResponse['sections'];
